import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Page } from '../../app/entities/pages/page';
import { FormControl } from '@angular/forms';
import { Pageable } from '../../app/entities/pages/pageable';
import { PaginationService } from '../../app/service/pagination.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'mc-pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit {
    totalItensPage: FormControl;
    pageNumber: number;
    pageTotal: number;
    subscription: Subscription;
    @Input() page: Page<any>;
    @Output() nextPageEvent = new EventEmitter();
    @Output() previousPageEvent = new EventEmitter();
    @Output() pageSizeEvent: EventEmitter<number> = new EventEmitter<number>();
    @Output() lastPageEvent = new EventEmitter();
    @Output() firstPageEvent = new EventEmitter();

    constructor(private service:PaginationService) {
        this.totalItensPage = new FormControl();
        this.totalItensPage.setValue(Pageable.DEFAULT_PAGE_SIZE);
        this.service.updatePagination.subscribe(page => this.setPagination(page));
    }

    ngOnInit() {
        this.setPagination(this.page);
    }

    ngOndestroy() {
        this.subscription.unsubscribe();
    }

    setPagination(page:Page<any>) {
        if(page !== undefined) {
            this.pageNumber = page.pageable.pageNumber + 1;
            this.pageTotal = page.totalPages;
        }
        else {
            this.pageNumber = 0;
            this.pageTotal = 0;
        }
    }

    nextPage(): void {
        this.nextPageEvent.emit(null);
    }

    previousPage(): void {
        this.previousPageEvent.emit(null);
    }

    updatePageSize(): void {
        this.pageSizeEvent.emit(this.totalItensPage.value);
    }

    firstPage(): void {
        this.firstPageEvent.emit(null);
    }

    lastPage(): void {
        this.lastPageEvent.emit(null);
    }
}


